import React, { useState } from 'react';
import Countdown from 'react-countdown';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router';
import { Button } from '@components-library/Button/Button';
import { countdownTimerService } from '@components-library/CountdownTimer/countdownTimer.service';
import { GiftIcon } from '@components-library/Icons/iconsComponents';
import { keyMap } from '@locales/lokalise/keyMap';
import { Popover } from 'antd';
import cn from 'classnames';
import { observer } from 'mobx-react';
import { useMobxStore } from 'store/mobx';
import { bonusService } from '../bonus.service';
import { BonusPopup } from './BonusPopup';
import { BonusPopupTimer } from './BonusPopupTimer';
import styles from './bonusPopup.module.scss';

export const BonusPopupHeaderButton = observer(() => {
  const [isPopoverOpen, setIsPopoverOpen] = useState(false);
  const { i18n } = useTranslation();
  const history = useHistory();

  const {
    notificationStore: {
      actualPopupNotifications,
      unreadPopupNotification,
      selectedNotification,
      setShowSelectedNotificationPopup,
      setHideSelectedNotificationPopup,
      setAcceptBonusProposal,
      setRejectBonusProposal,
    },
  } = useMobxStore();

  const navigateToMemberBonuses = () => {
    setIsPopoverOpen(false);
    history.push('/member/bonuses');
  };

  const navigateToDepositPage = () => {
    history.push(bonusService.getBonusProposalDepositLink());
  };

  const collectGift = (id: number) => {
    void setAcceptBonusProposal(id);
    navigateToDepositPage();
  };

  const rejectGift = (id: number) => {
    void setRejectBonusProposal(id);
  };

  if (actualPopupNotifications.length === 0) {
    return null;
  }

  return (
    <>
      {actualPopupNotifications.length === 1 ? (
        <>
          <BonusPopupTimer
            className={cn(styles.bonusPopupHeaderButtonTimer, styles.singleNotificationTimer)}
            colorTheme="inverted"
            expirationTime={actualPopupNotifications[0].expirationDate}
            onClick={() => setShowSelectedNotificationPopup(actualPopupNotifications[0].id)}
          />
          <button
            className={cn(styles.giftIconButton, styles.singleNotificationGift)}
            onClick={() => setShowSelectedNotificationPopup(actualPopupNotifications[0].id)}>
            <GiftIcon className={styles.giftIcon} />
            <div className={styles.giftIconCounter}>{actualPopupNotifications.length}</div>
          </button>
        </>
      ) : (
        <Popover
          rootClassName={styles.multipleItemsPopupContainerRoot}
          className={styles.multipleItemsPopupButtonContainer}
          placement="bottom"
          title={<span className={styles.title}>{i18n.t(keyMap.bonusesAvailableTableAvailableBonuses)}</span>}
          content={
            <div className={styles.multipleItemsPopupContainer}>
              {actualPopupNotifications.map((notification) => (
                <div key={notification.id} className={styles.notificationList}>
                  <div>{notification.subject}</div>
                  <div>
                    <Countdown
                      date={notification.expirationDate}
                      renderer={(props) => countdownTimerService.simpleRenderer(props, ['hours', 'minutes', 'seconds'])}
                    />
                  </div>
                </div>
              ))}
              <Button className="btn btn--tiny" onClick={navigateToMemberBonuses}>
                {i18n.t(keyMap.bonusesViewAllBonuses)}
              </Button>
            </div>
          }
          trigger="click"
          open={isPopoverOpen}
          onOpenChange={setIsPopoverOpen}>
          <button className={styles.giftIconButton}>
            <GiftIcon className={styles.giftIcon} />
            <div className={styles.giftIconCounter}>{actualPopupNotifications.length}</div>
          </button>
        </Popover>
      )}

      {selectedNotification ? (
        <BonusPopup
          onAccept={() => {
            setHideSelectedNotificationPopup();
            collectGift(selectedNotification.id);
          }}
          onReject={() => {
            setHideSelectedNotificationPopup();
            rejectGift(selectedNotification.id);
          }}
          selectedNotification={selectedNotification}
        />
      ) : (
        unreadPopupNotification && (
          <BonusPopup
            onAccept={() => collectGift(unreadPopupNotification.id)}
            onReject={() => rejectGift(unreadPopupNotification.id)}
            selectedNotification={unreadPopupNotification}
          />
        )
      )}
    </>
  );
});
